<form [formGroup]="teamForm" class="space-y-4 mt-2" (ngSubmit)="save()">

  <div class="grid grid-cols-2 md:grid-cols-2 gap-4">
    <p-floatlabel variant="on">
      <input pInputText id="team_name" formControlName="name" class="w-full" />
      <label for="team_name">Nome</label>
    </p-floatlabel>

    <p-floatlabel class="w-full" variant="on">
      <p-multi-select
        inputId="team_users"
        formControlName="user_ids"
        [options]="users"
        optionLabel="email"
        optionValue="id"
        appendTo="body"
        class="w-full"
      ></p-multi-select>
      <label for="team_users">Membri</label>
    </p-floatlabel>
  </div>

  <p-floatlabel variant="on">
    <textarea pTextarea id="team_description" formControlName="description" rows="4" class="w-full"></textarea>
    <label for="team_description">Descrizione</label>
  </p-floatlabel>

  <div class="flex justify-end gap-2">
    <p-button label="Cancel" icon="pi pi-times-circle" size="small" severity="secondary" (click)="closeDialog()"></p-button>
    <p-button label="Save" icon="pi pi-check-circle" size="small" [disabled]="!teamForm.valid" type="submit"></p-button>
  </div>
</form>
